module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro#toc_marker-2"
    }
  }, [_vm._v("Introduction: "), _c('i', [_vm._v("Defleshing the Human Experience")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-3"
    }
  }, [_vm._v("1 Rootless, Disengaged and Screen Addicted")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-4"
    }
  }, [_vm._v("2 The Schizophrenic Sense of Self")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Wandering Aimlessly in a Moral Minefield")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Moral Ambiguity of Our Time")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Religion as an Embodied Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Learning Embodiment from the Master")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Desire, Idolatry and Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 We Are Spirited Bodies")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Mission in the Excarnate Age")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Defying Church-World Dualism")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Placed Persons")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Adopting an Incarnational Posture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The First Page of the End of Despair")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#toc_marker-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Getting There")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epilogue#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: "), _c('i', [_vm._v("Christ in Us and We in Christ")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#toc_marker-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/aboutauthor#toc_marker-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/forge#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forge Missions Training Network")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#toc_marker-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0